import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { AccentButtonMediumOpenSans } from '../../../../../styledComponents/styles/Buttons.styled';
import { getLoginPath, setAuthCookie } from '../../../../../shared/helpers/sessionManagement';
import { loginAdmin } from '../../../../../actions/authActions';
import ScreenReaderHeadingComponent from '../../../../travelerProfile/components/heading/ScreenReaderHeadingComponent';

const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 21px;
`;

const Header = styled.span`
  color: #0b3544;
  font-size: 28px;
  font-weight: 600;
  line-height: 74px;
`;

const Instructions = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;

  span {
    font-weight: 600;
  }
`;

const SubmitContainer = styled.div`
  flex: 1;
  margin-top: 36px;
  text-align: center;
`;

// Step 5.
export default function CreatedStep(props) {
  let { control, errors, setValue, getValues, isValid, nextStep } = props;
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const forceLogin = () => {
    const email = getValues('email');
    const password = getValues('password');
    if (isValid) {
      dispatch(loginAdmin({ email: email, password: password }));
    }
  };

  useEffect(() => {
    if (!auth.isLoading && auth) {
      if (auth.user_id) {
        const isCookieSet = setAuthCookie({
          user_id: auth.user_id,
          email: auth.email,
          token: auth.token,
          client_id: auth.client_id,
          subdomain: auth.subdomain,
          expires_at: auth.expires_at
        });

        if (isCookieSet) {
          const accountPath = getLoginPath({
            admin_sign_in: auth.admin_sign_in,
            feature_legacy: auth.clientFeatureList.legacy,
            feature_vt: auth.clientFeatureList.travel_plans,
            freemium: auth.organization.status.toLowerCase() === 'free',
            lead: auth.organization.status.toLowerCase() === 'lead',
            redirect_jmp: '',
            organization: auth.organization,
          });

          window.location = accountPath;
        }
      }
    }
  }, [auth]);

  return (
    <>
      <ScreenReaderHeadingComponent text={'Account Created'} />
      <Header id="account-created" aria-live="polite">
        Account Created
      </Header>
      <Instructions>Your account is ready to explore.</Instructions>
      <ConfirmContainer>
        <lottie-player
          autoplay
          mode="normal"
          src="https://assets7.lottiefiles.com/packages/lf20_pwppxjbo.json"
          style={{ width: '150px', height: '150px' }}
        />
      </ConfirmContainer>
      <SubmitContainer>
        <AccentButtonMediumOpenSans aria-label="Enter" onClick={forceLogin}>
          Enter
        </AccentButtonMediumOpenSans>
      </SubmitContainer>
    </>
  );
}
